import $ from 'jquery';

const mobileMenuBreakpoint = 1200;
const $win = $(window);
const $body = $('body');

const $header = $('header.wp-block-template-part');
const $headerMenu = $('.site-header .site-header__wrap');
const $headerNav = $('.site-header .site-header__wrap .wp-block-navigation');

let isScrolled = false;
function NavigateMobileSubMenu(level, $subMenu) {
  $subMenu = $subMenu || null;
  if($subMenu) {
    $headerMenu.find('.sub-menu[data-level=' + level + ']').removeClass('active');
    $subMenu.addClass('active');
  }
  $headerNav.attr('data-currentlevel', level);
}
$(document).on('click', '.sub-menu-back', (e)=> {
  const $this = $(e.currentTarget)
  $this.parent().parent().removeClass('active')
})

$header.find('#menu-main-menu > .menu-item-has-children').each(function () {
  const $self = $(this);
  const $link = $self.find('> a');
  const $subMenu = $self.find('> .sub-menu');
  const $subMenuBack = $subMenu.find('> .sub-menu__back');
  const linkHref = $link.attr('href');
  if (linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
    const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
    $link.clone().appendTo($menuItemDuplicate);
    $subMenuBack.after($menuItemDuplicate);
  }

  $link.click(function (event) {
    if ($win.outerWidth() <= mobileMenuBreakpoint) {
      event.preventDefault();
      NavigateMobileSubMenu($subMenu.data('level'), $subMenu);
    }
  });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
  $headerNav.toggleClass('open');
  $(this).toggleClass('is-active');
});

// Add header height as css var.
function setMenuHeightVar() {
  $body.css('--header-height', $header.height() + 'px');
}

// Do this on resize
$(window)
$win.on('resize load', () => {
  setMenuHeightVar();
});
const navigation = document.querySelector('header.wp-block-template-part');

window.addEventListener( 'scroll', () => {
  if( window.scrollY > 0 ) {
    if(!isScrolled) {
      navigation.classList.add('scrolled');
      isScrolled = true;
    }
  } else {
    if (isScrolled) {
      navigation.classList.remove('scrolled');
      isScrolled = false;
    }
  }
})

$(window).on('scroll resize', function () {
  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const screenBottom = scrollTop + windowHeight;

  // Loop through every instance of .reveal independently
  $('.reveal').each(function () {
    const $this = $(this);

    // Skip calculations if this specific element is already revealed
    if ($this.hasClass('is-in')) return;

    const revealTop = $this.offset().top;

    // Trigger point: 5% down from the top of this specific container
    const triggerPoint = revealTop + ($this.outerHeight() * 0.05);

    // Add class to this specific instance once the screen bottom crosses its trigger point
    if (screenBottom >= triggerPoint) {
      $this.addClass('is-in');
    }
  });
});
